   if (window.sizeFinderData) {
       var sizeFinderRangeElement = document.getElementById('sizefinder_range')
       var sizeFinderInputElement = document.getElementById('sizefinder_input')
       var sizeFinderSelectedLengthElement = document.getElementById('sizefinder_selected_length')
       var sizeFinderSelectedSizesElement = document.getElementById('sizefinder_selected_sizes')

       if (sizeFinderRangeElement && sizeFinderInputElement) {
           // Calculate the min/max sizes
           let minMm = 999,
               maxMm = 0,
               avgDiffMm = 0
           for (let i = 0, l = sizeFinderData.length; i < l; i++) {
               minMm = Math.min(minMm, sizeFinderData[i].foot_length_mm.value)
               maxMm = Math.max(maxMm, sizeFinderData[i].foot_length_mm.value)

               if (i > 0) {
                   avgDiffMm += sizeFinderData[i].foot_length_mm.value - sizeFinderData[i - 1].foot_length_mm.value
               }
           }

           avgDiffMm = Math.round((avgDiffMm / sizeFinderData.length) / 2)
           minMm -= avgDiffMm
           maxMm += avgDiffMm

           // Calculate the conversion mapping between mm and sizes
           let sizesMmMap = {}
           for (let mm = minMm; mm <= maxMm; mm++) {
               sizesMmMap[mm] = null
           }

           // Size must be within 25mm
           const minScore = 25
           for (let i = 0, l = sizeFinderData.length; i < l; i++) {
               const sizeMm = ~~sizeFinderData[i].foot_length_mm.value

               if (sizeMm > 0) {
                   for (let deltaMm = -1 * minScore; deltaMm <= minScore; deltaMm++) {
                       const mm = sizeMm + deltaMm
                       const score = Math.abs(sizeMm - mm)

                       if (mm < minMm || mm > maxMm) {
                           continue
                       }

                       let shouldUse = false

                       if (!sizesMmMap[mm]) {
                           shouldUse = true

                       } else if (score <= sizesMmMap[mm].score) {
                           shouldUse = true
                       }

                       if (shouldUse) {
                           sizesMmMap[mm] = {
                               variant: sizeFinderData[i],
                               score: score,
                           }
                       }
                   }
               }
           }

           var currentVariant = null;
           for (let i = 0, l = sizeFinderData.length; i < l; i++) {
               if (sizeFinderData[i].current) {
                   currentVariant = sizeFinderData[i];
                   break;
               }
           }

           var currentValue = -1,
               triggerFromRange = false;

           function sizeFinderUpdate(value, fromRange, fromInput) {
               if (value == currentValue) {
                   return
               }

               value = Math.min(maxMm, Math.max(minMm, value));
               currentValue = value;

               var variant = value in sizesMmMap ? sizesMmMap[value].variant : false;

               if (variant) {
                   currentVariant = variant;

                   if (fromRange || fromInput) {
                       var sizeRadioInput = document.querySelector('input.radio__input[value="' + variant.options[0] + '"]');

                       if (sizeRadioInput) {
                           sizeRadioInput.checked = true;

                           triggerFromRange = true;
                           sizeRadioInput.dispatchEvent(new Event('change'));
                           triggerFromRange = false;
                       }
                   }

                   sizeFinderSelectedLengthElement.innerHTML = (value / 10).toFixed(1) + 'cm';
                   sizeFinderSelectedSizesElement.innerHTML = variant.sizes.map((size) => size.replaceAll(' ', '&nbsp;')).join(' / ');
               }

               if (!fromRange) {
                   sizeFinderRangeElement.value = value;
               }

               if (!fromInput) {
                   sizeFinderInputElement.value = value / 10;
               }
           }

           sizeFinderRangeElement.setAttribute('step', 1);
           sizeFinderRangeElement.setAttribute('min', minMm);
           sizeFinderRangeElement.setAttribute('max', maxMm);

           sizeFinderRangeElement.addEventListener('input', () => {
               sizeFinderUpdate(parseInt(sizeFinderRangeElement.value), true, false);
           })

           sizeFinderInputElement.addEventListener('keyup', (e) => {
               sizeFinderUpdate(Math.round(parseFloat(sizeFinderInputElement.value || 0, 10) * 10), false, true);
           })

           sizeFinderInputElement.addEventListener('blur', (e) => {
               sizeFinderUpdate(Math.round(parseFloat(sizeFinderInputElement.value || 0, 10) * 10), false, false);
           })

           sizeFinderUpdate(currentVariant ? currentVariant.foot_length_mm.value : Math.round((minMm + (maxMm - minMm) / 2) / 5) * 5)

           Array.prototype.slice.call(document.querySelector('[data-product-form]').querySelectorAll('[name^="options"]')).map(function(element) {
               var value = null;
               for (let i = 0, l = sizeFinderData.length; i < l; i++) {
                   if (sizeFinderData[i].options[0] === element.value) {
                       value = sizeFinderData[i].foot_length_mm.value;
                       break;
                   }
               }

               element.addEventListener('change', function() {
                   if (!triggerFromRange) {
                       sizeFinderUpdate(value, false)
                   }
               });
           });
       }
   }